// extracted by mini-css-extract-plugin
export default {"spanColor":"movementsCard_spanColor__ZLGrl","title":"movementsCard_title__Jj60P","content":"movementsCard_content__H6q8a","link":"movementsCard_link__SXd7Z"};